import { MerchantMarket } from "../types/merchant/MerchantMarket"

export function getMerchantMarketByCountryCode(countryCode: string): MerchantMarket {
    if (["NO", "SE", "DK"].includes(countryCode)) {
        return "Scandinavia"
    }
    return "Other"
}
